<style>
	@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Activation Request" title="View Activation Request" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					
					<div class="card">
						<div class="card-body">

                            <div class="col-md-12 filter-sort">
								<div class="row">

                                    <div class="col-md-3">
										<select class="form-select" v-model="action_type" @change="fetchActivationRequest()">
                                            <option value="">Select Action</option>
                                            <option :value="action.id" v-for="action in actions" :key="action.id">
														{{action.action_name}}
											</option>
                                        </select>
									</div>

									<div class="col-md-3">
										<select class="form-select" v-model="status"  @change="fetchActivationRequest()">
                                            <option value="">Select Status</option>
                                            <option value="0">Pending</option>
                                            <option value="1">Ongoing</option>
                                            <option value="2">Approved</option>
                                            <option value="3">Rejected</option>
                                        </select>
									</div>

									<div class="col-md-3">

									</div>

                                    <div class="col-md-3 float-end">
										<input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchActivationRequest()"/>
									</div>
								</div>
							</div>
		
							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
											<th>Sl.No</th>
											<th>Request Date</th>
											<th>Company Name</th>
											<th>Request Type</th>
                                            <th>Count</th>
											<th>Action Type</th>
											<th>Request ID</th>
											<th>Status</th>
											<th>Action</th>
										</tr>
									</thead>

									<tbody v-if="Boolean(requests.length)">
										<tr v-for="(request, index) in requests" :key="request.id" align="center">
                                            <td>{{ index + 1}}</td>
											<td>{{ request.request_date }}</td>
                                            <td>{{ request.company }}</td>
                                            <td>SimActivation</td>
                                            <td>{{ request.count }}</td>
                                            <td>{{ request.action.action_name }}</td>
											<td>
												<span class="clickable-text" @click="downloadFile(request)">
													{{ request.request_id }}
												</span>
											</td>
                                            <td>
                                                <span class="badge rounded-pill bg-warning" v-if="request.status==0">Pending</span>
                                 		        <span class="badge rounded-pill bg-info" v-if="request.status==1">Ongoing</span>
                                                <span class="badge rounded-pill bg-success" v-if="request.status==2">Approved</span>
                                                <span class="badge rounded-pill bg-primary" v-if="request.status==3">Rejected</span>
                                            </td>
                                            <td>
                                                <div v-if="request.status==0" class="example-popover" data-container="body" data-bs-toggle="tooltip" data-bs-placement="top" title="Upload" @click="openModal(request.id)">
                                                    <i class="icofont icofont-upload-alt"></i>
                                                </div>
                                                <div v-else class="example-popover" data-container="body" data-bs-toggle="tooltip" data-bs-placement="top" title="Download">
                                                    <i class="icofont icofont-download-alt"></i>
                                                </div>
                                            </td>
                                        </tr>	
									</tbody>

									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available in the table</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchActivationRequest(page.url + '&action=' + action + '&status=' + status +  '&limit=' + listing_length)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
		
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title="modal_title">
			<template #body>
				<form @submit.prevent="uploadExcel" enctype="multipart/form-data">
					<div class="row mt-3">
						<div class="col-md-12 form-group">
							<!-- <label class="control-label">Logo </label> -->
							<input class="form-control" type="file" @change="setFile($event)" accept=".csv" />
						</div>
					</div>
					
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" >{{ button_title }}</button>
						<button class="btn btn-light" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>
	  
   </div>
</template>


<script>
import {
    Tooltip
} from 'bootstrap/dist/js/bootstrap.esm.min.js'
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Coupons eport",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},
		
		data() {

			const now = new Date()
			const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
			const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
			const minDate = new Date('2021-01-01') 
	      
			return {
				actions: [],
				pagination: {},
				start_date: '2021-01-01',
				end_date: today_str,
				
				min: minDate,
				max: today,
				keyword: "",
				listing_length: 10,
				token: "",
				i: 1,				

				modal_title: "Upload Excel",
				button_title: "Upload",

                action_type: "",
                status: "",

                requests: [],

				file:"",
				Preview_image:"",
				selected_request_id: null,
				hover: false

			};
		},
		mounted() {
            new Tooltip(document.body, {
                    selector: "[data-bs-toggle='tooltip']",
                })
        },
        unmounted() {

            let popovers = document.getElementsByClassName('tooltip')
            // popovers.forEach(item => {
            //     item.remove()
            // })

        },

		created() {
			this.fetchAction();
			this.fetchActivationRequest();
		},

		methods: {

			getToken() {
				if (localStorage.getItem('trazio')) {
				var trazio =  JSON.parse(localStorage.getItem('trazio'));
				if(trazio.token) {

					this.token = trazio.token;
					this.user = trazio;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}

				} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
				}
			},

			fetchAction(page_url = null) {
				this.getToken();
				let url = "/trazio/getActions";
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.actions = responseData.actions;
					})
					.catch((err) => console.log(err));
			},

			fetchActivationRequest(page_url = null) {
				this.getToken();
				let url = "/trazio/activationRequestData?limit=" + this.listing_length + "&keyword=" + this.keyword + "&action=" + this.action_type + "&status=" + this.status;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.requests = responseData.activationRequest.data;
						this.pagination = responseData.activationRequest.links;
						this.from = responseData.activationRequest.from;
						this.to = responseData.activationRequest.to;
						this.total = responseData.activationRequest.total;
					})
					.catch((err) => console.log(err));
			},

			setFile(e) {
				this.file = e.target.files[0];
				this.Preview_image = URL.createObjectURL(e.target.files[0]);
				
			},

			uploadExcel() {
				this.getToken();

				const config = {
					headers: {
					"Content-type": "multipart/form-data",
					Accept: "application/json",
					Authorization: "Bearer " + this.token,
					},
				};

				let url = "trazio/updateActivationRequest";
				{
					{
					this.token;
					}
				}
				let formData = new FormData();
				formData.append("file", this.file);
				formData.append("id", this.selected_request_id); 

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.clearForm();
						this.closeModal();
						this.fetchActivationRequest();
					})
					.catch((error) => {
						console.log(error);
						console.log(error.response);
						if (error.response) {
							if (error.response.status == 422) {
								if (error.response.data) {
									this.errors = error.response.data.message;
								}
								this.$swal("", error.response.statusText, "error");
							} else if (error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");
							} else if (error.response.status == 401) {
								this.$swal("", error.response.statusText, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", error.message, "error");
						}
					});
			},

			downloadFile(request) 
			{
				this.getToken();
				let page_url = "trazio/downloadActivationRequest?request_id=" + request.id;
				this.$axios
				.get(page_url, { headers: { Authorization: "Bearer " + this.token }, responseType: "arraybuffer", })
				.then((response) => {

					let blob = new Blob([response.data], { type: "application/pdf" });
					let link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download ="Activation_" + request.request_id + ".csv";

					link.click();
						
				})
				.catch((err) => console.log(err));
			},

			openModal(id) {
				this.selected_request_id = id;
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},
            
			clearForm() {
				this.edit = false;
				this.modal_title = "Upload Excel";
				this.button_title = "Upload";
				this.errors = {};
			},

		},
	};
</script>
